/**
 * @graphql agg
 */

import gql from 'graphql-tag';

export const SearchResultsAGGSearchQuery = gql`
	query SearchResultsAGGSearchQuery(
		$query: String!
		$cloudIdARI: [String!]!
		$limit: Int!
		$entities: [String!]!
		$commonFilters: SearchCommonFilter
		$confluenceFilters: SearchConfluenceFilter
		$sort: [SearchSortInput]
		$after: String
		$disableQueryReplacement: Boolean
		$experience: String!
		$isLicensed: Boolean!
		$includeRecommended: Boolean = false
		$spaceId: String!
		$tenantId: String!
	) {
		search {
			results: search(
				experience: $experience
				query: $query
				first: $limit
				after: $after
				sort: $sort
				disableQueryReplacement: $disableQueryReplacement
				filters: {
					entities: $entities
					locations: $cloudIdARI
					commonFilters: $commonFilters
					confluenceFilters: $confluenceFilters
				}
			) {
				totalCount
				edges {
					node {
						id
						__typename
						description
						iconUrl
						title
						type
						url
						... on SearchConfluencePageBlogAttachment {
							lastModified
							isVerified
							space {
								id
								name
								webUiLink
							}
							... on SearchConfluencePageBlogAttachment @include(if: $isLicensed) {
								watchDialogContent: content {
									id
									__typename
									currentUserIsWatching
									space {
										currentUser {
											isWatched
											isWatchingBlogs
										}
										operations {
											operation
											targetType
										}
									}
								}
							}
							content {
								id
								__typename
								blank
								excerpt
							}
							confluenceEntity {
								... on ConfluencePage {
									id
									__typename
									title
									type
									subtype
									pageStatus: status
									links {
										webUi
										editUi
									}
									metadata {
										titleEmojiPublished {
											__typename
											id
											key
											value
										}
										titleEmojiDraft {
											__typename
											id
											key
											value
										}
									}
									editorVersion: properties(keys: ["editor"]) {
										__typename
										key
										value
									}
									space {
										id
										key
										alias
										name
									}
									author {
										user {
											id
											picture
											name
										}
									}
									owner {
										user {
											id
											picture
											name
										}
									}
									viewer {
										favoritedSummary {
											isFavorite
										}
									}
									commentCountSummary {
										total
									}
									likesSummary {
										count
									}
								}
								... on ConfluenceBlogPost {
									id
									__typename
									title
									type
									blogPostStatus: status
									links {
										webUi
										editUi
									}
									metadata {
										titleEmojiPublished {
											__typename
											id
											key
											value
										}
										titleEmojiDraft {
											__typename
											id
											key
											value
										}
									}
									editorVersion: properties(keys: ["editor"]) {
										__typename
										key
										value
									}
									space {
										id
										key
										alias
										name
									}
									author {
										user {
											id
											picture
											name
										}
									}
									owner {
										user {
											id
											picture
											name
										}
									}
									viewer {
										favoritedSummary {
											isFavorite
										}
									}
									commentCountSummary {
										total
									}
									likesSummary {
										count
									}
								}
								... on ConfluenceEmbed {
									id
									__typename
									title
									type
									contentStatus: status
									links {
										webUi
									}
									metadata {
										titleEmojiPublished {
											__typename
											id
											key
											value
										}
										titleEmojiDraft {
											__typename
											id
											key
											value
										}
									}
									space {
										id
										key
										alias
										name
									}
									author {
										user {
											id
											picture
											name
										}
									}
									owner {
										user {
											id
											picture
											name
										}
									}
									viewer {
										favoritedSummary {
											isFavorite
										}
									}
									commentCountSummary {
										total
									}
								}
								... on ConfluenceDatabase {
									id
									__typename
									title
									type
									contentStatus: status
									links {
										webUi
									}
									space {
										id
										key
										alias
										name
									}
									author {
										user {
											id
											picture
											name
										}
									}
									owner {
										user {
											id
											picture
											name
										}
									}
									viewer {
										favoritedSummary {
											isFavorite
										}
									}
									commentCountSummary {
										total
									}
								}
								... on ConfluenceWhiteboard {
									id
									__typename
									title
									type
									contentStatus: status
									links {
										webUi
									}
									space {
										id
										key
										alias
										name
									}
									author {
										user {
											id
											picture
											name
										}
									}
									owner {
										user {
											id
											picture
											name
										}
									}
									viewer {
										favoritedSummary {
											isFavorite
										}
									}
									commentCountSummary {
										total
									}
								}
								... on ConfluenceFolder {
									id
									__typename
									title
									type
									contentStatus: status
									links {
										webUi
									}
									space {
										id
										key
										alias
										name
									}
									author {
										user {
											id
											picture
											name
										}
									}
									owner {
										user {
											id
											picture
											name
										}
									}
									viewer {
										favoritedSummary {
											isFavorite
										}
									}
								}
							}
						}
					}
				}
				totalCount
				totalCounts {
					product
					count
				}
				pageInfo {
					endCursor
				}
			}
		}

		smarts @include(if: $includeRecommended) {
			recommendedObject(
				recommendationsQuery: {
					context: {
						userId: "context"
						tenantId: $tenantId
						product: "confluence"
						containerId: $spaceId
					}
					modelRequestParams: { experience: $experience, caller: "confluence" }
					requestingUserId: "context"
				}
			) {
				content {
					id
					__typename
					blank
					excerpt(length: 372)
				}
				object {
					... on ConfluencePage {
						id
						__typename
						title
						type
						subtype
						pageStatus: status
						links {
							webUi
							editUi
							__typename
						}
						metadata {
							titleEmojiDraft {
								__typename
								id
								key
								value
							}
							titleEmojiPublished {
								__typename
								id
								key
								value
							}
						}
						viewer {
							favoritedSummary {
								isFavorite
							}
						}
						editorVersion: properties(keys: ["editor"]) {
							__typename
							key
							value
						}
						space {
							id
							__typename
							key
							alias
							name
						}
						author {
							user {
								id
								__typename
								picture
								name
							}
						}
						owner {
							user {
								id
								picture
								name
							}
						}
						latestVersion {
							author {
								user {
									id
									__typename
									picture
									name
								}
							}
							createdAt
						}
						commentCountSummary {
							total
						}
						likesSummary {
							count
						}
					}
					... on ConfluenceBlogPost {
						id
						__typename
						title
						type
						blogPostStatus: status
						links {
							webUi
							editUi
							__typename
						}
						metadata {
							titleEmojiDraft {
								__typename
								id
								key
								value
							}
							titleEmojiPublished {
								__typename
								id
								key
								value
							}
						}
						viewer {
							favoritedSummary {
								isFavorite
							}
						}
						editorVersion: properties(keys: ["editor"]) {
							__typename
							key
							value
						}
						space {
							id
							__typename
							key
							alias
							name
						}
						author {
							user {
								id
								__typename
								picture
								name
							}
						}
						owner {
							user {
								id
								picture
								name
							}
						}
						latestVersion {
							author {
								user {
									id
									__typename
									picture
									name
								}
							}
							createdAt
						}
						commentCountSummary {
							total
						}
						likesSummary {
							count
						}
					}
				}
			}
		}
	}
`;
